import { FC, ReactNode } from 'react';
import { Card, CardProps, useColorModeValue } from '@chakra-ui/react';
import { motion } from 'framer-motion';

// Animation variants
export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6,
      staggerChildren: 0.1
    }
  }
};

export const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

export const boxVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6,
      staggerChildren: 0.1
    }
  }
};

// Create motion components
const MotionCard = motion(Card);

// export interface MotionCardProps extends CardProps, HTMLMotionProps<'div'> {
export interface MotionCardProps extends CardProps {
  children: ReactNode;
  variants?: any;
}

export const AnimatedCard: FC<MotionCardProps> = ({
  children,
  variants = cardVariants,
  ...props
}) => {
  return (
    <MotionCard
      p={6}
      flex="1"
      border="1px solid"
      borderColor={useColorModeValue("gray.200", "gray.700")}
      boxShadow="none"
      transition="border-color 0.2s"
      variants={variants}
      {...props}
    >
      {children}
    </MotionCard>
  );
};

export default AnimatedCard; 